import { useRef, useState } from 'react'
import { Icon } from '@iconify/react'
import Dashboard from '../../layout/Dashboard'
import { Content, Heading } from '../../styles/OverviewStyle'
import FilterDropdown from '../../components/FilterDropdown'
import type { FilterState } from '../../../types/FilterStateInterface'
import { ListHead, ListRow, NavContainer, NavWrapper } from '../../styles/CrypoAssetStyle'
import { useNavigate } from 'react-router'

type Log = { id: string; date: string; description: string; admin: string; role: AdminRole }

enum AdminRole {
   SUPER_ADMIN = 'Super-Admin',
   ADMINISTRATOR = 'Administrator',
   ANALYST = 'Analyst',
}

const AdminRoleStyle: Record<AdminRole, string> = {
   [AdminRole.SUPER_ADMIN]: 'bg-[#FBF5FF] text-[#761BB8]',
   [AdminRole.ADMINISTRATOR]: 'bg-[#F5F9FF] text-[#1B52B8]',
   [AdminRole.ANALYST]: 'bg-[#F5FFF5] text-[#1EB81B]',
}

const LOGS: Log[] = [
   { id: 'a1', date: 'Aug 18, 2025 at 4:05:56 AM', description: 'Sent ₦50,000 to 3 users', admin: 'Omotayo Pellegrini', role: AdminRole.SUPER_ADMIN },
   { id: 'a2', date: 'May 14, 2025 at 16:23:44 PM', description: 'Approved sale of $100 Apple iTunes card', admin: 'Kelli Donnelly', role: AdminRole.ADMINISTRATOR },
   { id: 'a3', date: 'Jul 30, 2025 at 7:45:37 AM', description: 'Blocked user @johndoe92', admin: 'Omotayo Pellegrini', role: AdminRole.SUPER_ADMIN },
   { id: 'a4', date: 'Jul 30, 2025 at 7:45:37 AM', description: 'Approved user KYC verification @pisuYana_+2', admin: 'Mandy Gulgowski', role: AdminRole.ADMINISTRATOR },
   { id: 'a5', date: 'Jul 30, 2025 at 7:45:37 AM', description: 'Sent push notification "New rates updated"', admin: 'Phil Ortiz', role: AdminRole.ANALYST },
]

export default function ActivityLog(): React.JSX.Element {
   const [query, setQuery] = useState('')
   const [filters, setFilters] = useState<FilterState>({ types: [], currencies: [], statuses: [], ranges: [] })
   const [open, setOpen] = useState(false)
   const filterBtnRef = useRef<HTMLButtonElement | null>(null)

   const filtered = LOGS.filter(l => (l.date + l.description + l.admin + l.role).toLowerCase().includes(query.toLowerCase()))

   const navigate = useNavigate()

   return (
      <Dashboard title="Notification / Activity Log" icon="solar:clock-circle-linear" active="notifications">
         <Content>
            <div className="flex items-center justify-between mb-4">
               <Heading>Notification</Heading>
               <div />
            </div>

            <NavContainer>
               <NavWrapper children="Push Notification" onClick={() => navigate('/notifications')} />
               <NavWrapper children="Activity Log" $active />
            </NavContainer>

            <div className="flex items-center gap-2 mt-6 mb-4">
               <div className="flex items-center gap-2 bg-white border border-[#EDEDEE] rounded-md px-[9px] py-[6px] w-[229px] h-[28px]">
                  <Icon icon='solar:magnifer-linear' width={14} className="text-[#B3B3B6] mb-0.5" />
                  <input
                     value={query}
                     onChange={e => setQuery(e.target.value)}
                     placeholder="Search"
                     className="flex-1 bg-transparent outline-none text-[12px] font-medium tracking-tight placeholder:text-[#B3B3B6]" />
               </div>

               <div className="relative">
                  <button
                     ref={filterBtnRef}
                     onClick={() => setOpen(o => !o)}
                     className="flex items-center gap-1.5 px-3 py-1.5 h-[28px] text-xs tracking-tight bg-white border border-[#E7E7E9] rounded-lg cursor-pointer hover:bg-[#F9F9FA] transition-colors"
                  >
                     <Icon icon='solar:sort-outline' width={16} />
                     <span className='text-neutral-900 font-medium'>Filter</span>
                  </button>
                  <FilterDropdown
                     open={open}
                     onClose={() => setOpen(false)}
                     value={filters}
                     onChange={setFilters}
                     anchorRef={filterBtnRef}
                  />
               </div>
            </div>

            <div>
               <ListHead style={{ gridTemplateColumns: '220px 1fr 240px 120px' }}>
                  <div className="text-[12px] tracking-tight text-[#9C9C9F]">Date</div>
                  <div className="text-[12px] tracking-tight text-[#9C9C9F]">Description</div>
                  <div className="text-[12px] tracking-tight text-[#9C9C9F]">Admin name</div>
                  <div className="text-[12px] tracking-tight text-center ml-14 text-[#9C9C9F]">Role</div>
               </ListHead>

               {filtered.map((l: Log) => (
                  <ListRow key={l.id} style={{ gridTemplateColumns: '220px 1fr 225px 120px' }}>
                     <div className="text-xs text-[#9C9C9F]">{l.date}</div>
                     <div className="text-sm text-[#101018] font-medium">{l.description}</div>
                     <div className="text-sm text-[#6D6D72]">{l.admin}</div>
                     <div className="text-sm text-right"><span className={`px-3 py-1 rounded-full text-xs font-geist-mono ${AdminRoleStyle[l.role]}`}>{l.role}</span></div>
                  </ListRow>
               ))}
            </div>
         </Content>
      </Dashboard>
   )
}
